import React from 'react';

const defaultContext = {
  open: false,
  modalId: '',
  toggle: () => {},
};

export const HelpModalContext = React.createContext(defaultContext);
